// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { savedOrderDetailsCartLineStyles } from "@conklin/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

savedOrderDetailsCartLineStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

savedOrderDetailsCartLineStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

savedOrderDetailsCartLineStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

savedOrderDetailsCartLineStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

savedOrderDetailsCartLineStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

savedOrderDetailsCartLineStyles.cartLineErrorMessageText = {
    ...cartLineSharedStyles.errorMessage,
};

savedOrderDetailsCartLineStyles.extendedUnitNetPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

savedOrderDetailsCartLineStyles.productInfoContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};

savedOrderDetailsCartLineStyles.cartLineContainerStyles = {
    remove: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / 3;
                grid-row: 5 / 6;
                margin-top: 8px;
                display: flex;
            }
        `,
    },
};

savedOrderDetailsCartLineStyles.quoteMessageWrapper = {
    ...cartLineSharedStyles.quoteMessage?.quoteMessageWrapper,
};

savedOrderDetailsCartLineStyles.quoteTotal = {
    ...cartLineSharedStyles.quoteMessage?.quoteTotal,
};
savedOrderDetailsCartLineStyles.quoteText = {
    ...cartLineSharedStyles.quoteMessage?.quoteText,
};

savedOrderDetailsCartLineStyles.quoteTooltip = {
    ...cartLineSharedStyles.quoteMessage?.quoteTooltip,
};
